import { createFileRoute } from "@tanstack/react-router";
import { Catalog } from "../../../features/console/catalog";

export const Route = createFileRoute("/_authed/$org/$project/ui-catalog")({
  validateSearch: (s: Record<string, unknown>): { tab?: string } => (typeof s.tab === "string" ? { tab: s.tab } : {}),
  component: CatalogPage,
});

function CatalogPage() {
  const { org, project } = Route.useParams();
  const { tab = "list" } = Route.useSearch();
  return <Catalog scope={{ org, project }} tab={tab} />;
}
